export default __webpack_public_path__ + "static/Montserrat-Bold-63fae500fdcf19ce83d4e55c5dbb744b.ttf";